interface IBufferedFile {
    buffer: ArrayBuffer;
    mimeType: string;
    name: string;
}

export class BufferedFile implements IBufferedFile {
    buffer: ArrayBuffer;
    mimeType: string;
    name: string;

    constructor(stream: ArrayBuffer, mimeType: string, name: string) {
        this.buffer = stream;
        this.mimeType = mimeType;
        this.name = name;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/bufferedFile.ts